; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Components/ContentSearch/SearchResults',["jquery", "eventManager", "knockout", "ScoreSearchResults", "score_bootstrap/Events/SearchResponseEvent", "score_bootstrap/Models/Search/SearchRequest", "score_bootstrap/Components/ContentSearch/SearchResultsBase", "score_bootstrap/Models/Tile", "score_bootstrap/Utils/UrlHelper"], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require("knockout"), require("ScoreSearchResults"), require("score_bootstrap/Events/SearchResponseEvent"), require("score_bootstrap/Models/Search/SearchRequest"), require("score_bootstrap/Components/ContentSearch/SearchResultsBase"), require("score_bootstrap/Models/Tile"), require("score_bootstrap/Utils/UrlHelper")) :
            console && console.error('SearchResults does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, ko, ScoreSearchResults, SearchResponseEvent, SearchRequest, SearchResultsBase, Tile, urlHelper) {

    var tileCache = {};

    function SearchResults(scope, uniqueId, refreshEvents, showMessages, isLazySearch, tileName, switchToClassicPager, classicPagesToDisplay, showEllipsisInBetween, scrollToPageTop) {
        // read query from GET parapmeter if any passed on page load
        this.searchQuery = ko.observable(new SearchRequest().query);

        // subscribe to search result update and read query from the response
        eventManager.subscribe(SearchResponseEvent.eventName, this._handleSearchQueryUpdate.bind(this));

        // replace token received from the server side with a knockout element
        var $counter = $('.displaying-results', scope);
        if ($counter.length) {
            $counter.attr('data-bind', 'visible: showNumberOfResultsLabel()');
            $counter.html($counter.html().replace('%searchquery%', '<span data-bind="text: searchQuery"></span>'));
        }



        // call inherited class constructor
        ScoreSearchResults.call(this, scope, uniqueId, refreshEvents, showMessages, isLazySearch, tileName, switchToClassicPager, classicPagesToDisplay, showEllipsisInBetween, scrollToPageTop);
        tileCache[this.id] = {};

        // find tally holder
        this.initTallyHolder();
    }

    // inherit 
    SearchResults.prototype = Object.create(ScoreSearchResults.prototype);

    // SCORE normally hides the # of results label unless the user is searching for something
    SearchResults.prototype.showNumberOfResultsLabel = function showNumberOfResultsLabel() {
        return true; //this.searchQuery() && this.searchQuery().length > 0;
    }

    SearchResults.prototype.appendTiles = function appendTiles(response) {
        var newTiles = [], lastRowTiles = [], self = this;

        this.serviceUnavailable(false);

        // update tally number, if tally holder is presented
        this.updateTallyHolderText(response.totalItems);

        if (response.page !== this.page) {
            urlHelper.setHashValue(window.location, this.id + "page", String(response.page));
        }
        else {
            // Remove page hash if it's the first page
            urlHelper.setHashValue(window.location, this.id + "page", null);
            if (!window.location.hash) urlHelper.removeHash();
        }

        if (response.page <= this.page) {
            // When there is a new search response, current tiles should always be cleared out first,
            // unless the 'page' value has been incremeneted, which means that 'show more' was clicked
            this.reset();
        } else {
            // 'show more' was clicked, so page should be incremented
            this.page = response.page;

            //lastRowTiles = SearchResultsBase.getLastRowTiles(this);
        }

        var originalQuantity = this.tiles.length;

        response.items.forEach(function (item) {
            var id = item.id.toString(), tile, cache = tileCache[this.id];

            if (!cache.hasOwnProperty(id)) {
                cache[id] = new Tile(item, this.tileName);
            }

            tile = cache[id];
            this.results.push(tile);
            newTiles.push(tile.element());
        }, this);

        // store amount pages for a classic pager
        this.totalPages(response.totalPages);
        this.currentPage(response.page);
        this.allPages.removeAll();
        Array.apply(null, { length: response.totalPages }).map((function (v, i) { this.allPages.push(i); }).bind(this));
        this.showPager(response.totalPages > 1 && this.switchToClassicPager);


        this.canShowMore((response.page + 1) < response.totalPages);
        this.numberOfResults(response.totalItems);
        this.query(response.query);

        this.overrideNumberOfResults();

        eventManager.trigger("SearchResultsQueryMessage", this.scope, this.numberOfResults());

        if ((this.numberOfResults()|0) <= 0) {
            eventManager.trigger('empty-search-result', this.scope);
        }

        if (!newTiles.length) {

            if ($(self.scope).hasClass("js-hide-on-load")) {
                $(self.scope).removeClass("js-hide-on-load");
            }
            return;
        }

        newTiles = $(newTiles).add(SearchResultsBase.injectPromoTiles(this, originalQuantity));

        if (!this.includeMatchHeight) {
            if ($(self.scope).hasClass("js-hide-on-load")) {
                $(self.scope).removeClass("js-hide-on-load");
            }
            return;
        }

        // Wait to run matchHeight until all the images are loaded since
        // height of images affect the height of the tiles
        //imagesLoaded($("img", newTiles), function matchHeightOnNewTiles() {
        //    var emptySpots = self.tilesPerRow - lastRowTiles.length;
        //    if (emptySpots > 0) {
        //        $(newTiles.slice(0, emptySpots)).add(lastRowTiles).matchHeight(true);
        //        newTiles = newTiles.slice(emptySpots);
        //    }

        //    $(newTiles).matchHeight(true);
        //    if ($(self.scope).hasClass("js-hide-on-load")) {
        //        $(self.scope).removeClass("js-hide-on-load");
        //    }
        //});

        // explicitly providing hook to tenants for search rendering

        eventManager.trigger("search-rendered", this.scope);

        // call base class implementation
        SearchResultsBase.prototype.appendTiles.call(this, newTiles);

        if ($(self.scope).hasClass("js-hide-on-load")) {
            $(self.scope).removeClass("js-hide-on-load");
        }

        if (this.initialResultLoaded && this.scrollToPageTop) {
            this.scrollToTopResults();
        }

        //eventManager.trigger("SearchResultsQueryMessage", this.scope, this.numberOfResults());
        // setup the initial release was loaded
        this.initialResultLoaded = !0;

    }

    SearchResults.prototype.getPages = function getPages() {

        if (this.totalPages() <= this.classicPagesToDisplay || this.classicPagesToDisplay <= 0) {
            return this.allPages();
        } else {
            var first = 0;

            var upperLimit = this.currentPage() + Math.round((this.classicPagesToDisplay - 1) / 2);
            var downLimit = this.currentPage() - parseInt((this.classicPagesToDisplay - 1) / 2);

            while (upperLimit >= this.totalPages()) {
                upperLimit--;
                if (downLimit > first)
                    downLimit--;
            }

            while (downLimit < first) {
                downLimit++;
                if (upperLimit < this.totalPages())
                    upperLimit++;
            }

            var pages = [];
            for (var i = downLimit; i <= upperLimit; i++) {
                pages.push(i);
            }

            return ko.observableArray(pages);
        }
    };



    /*
     * Find a holder for search results tally.
     * In the current implementation we support only a tally holder within a TabSet.
     * If you want to have it in any other place, please extend this method
     */
    SearchResults.prototype.initTallyHolder = function initTallyHolder() {
        var $tabSet = this.$scope.closest('.ipa-js-embed-search-tally-in-the-title');
        // if the current search results isn't under a tabset which with a specific marker - skip the tally logic.
        if (!$tabSet.length) {
            return !1;
        }

        var $tabPanel = this.$scope.closest('.tab-pane');
        // make sure the search results is in a TabPane, otherwise just skip this logic.
        if (!$tabPanel.length) {
            return !1;
        }
        var tabId = $tabPanel.attr('id');

        var $tabLink = $tabSet.find('>.nav-tabs-wrapper-outer>.nav-tabs-wrapper-inner>.nav-tabs>li>*[href=\'#' + tabId + '\']');
        if (!$tabLink.length) {
            return !1;
        }

        var $tallyHolder = $tabLink.find('>.ipa-js-search-tally');
        if (!$tallyHolder.length) {
            // if tally isn't presented in the tab panel header - add it dynamicly
            $tallyHolder = $('<span class=\'ipa-js-search-tally\'></span>');
            $tabLink.append($tallyHolder);
        }

        // save tally holder which can later be used in appendTile() method.
        this.$tallyHolder = $tallyHolder;
    }

    SearchResults.prototype.overrideNumberOfResults = function overrideNumberOfResults() {
        var $numberOfResults = $('.displaying-results', this.scope);

        var numOfResults = this.numberOfResults();
        var currentPage = this.currentPage();
        var numberPerPage = this.searchClient.searchRequest.perPage;

        var firstResult =
            numOfResults === 0 ? 0 : currentPage * numberPerPage + 1;
        var lastResult = currentPage * numberPerPage + numberPerPage;
        //On the last page use the actual last results number instead of the calculated one
        lastResult = lastResult > numOfResults ? numOfResults : lastResult;

        var newMarkup =
            firstResult.toLocaleString() +
            "-" +
            lastResult.toLocaleString() +
            " of " +
            numOfResults.toLocaleString() +
            " Results";

        $numberOfResults.html(newMarkup);
    }

    SearchResults.prototype.updateTallyHolderText = function updateTallyHolderText(number) {
        // if tally holder defined, lets update it's value
        if (!this.$tallyHolder || !this.$tallyHolder.length) {
            return !1;
        }

        this.$tallyHolder.text('(' + number + ')');
        if (number <= 0) {
            // disable tab. 
            var $link = this.$tallyHolder.closest('a');
            $link.prop('disabled', true);
            // when a tab is disabled, the hash goes to the URL. 
            // we want to prevent that, the function below is handling that.
            $link.on('click.score', function (e) {
                e.preventDefault();
                e.stopPropagation();
                return !1;
            });
            var $tab = $link.closest('li');
            if (!$tab.is('.disabled')) {
                $tab.addClass('disabled');
            }
        } else {
            var $link = this.$tallyHolder.closest('a');
            $link.prop('disabled', false);
            // remove function which we assigned above to prevent hash to be in the url.
            $link.off('click.score');
            var $tab = $link.closest('li');
            $tab.removeClass('disabled');
        }

    }


    SearchResults.prototype._handleSearchQueryUpdate = function _handleSearchQueryUpdate(response) {
        this.searchQuery(response.query);
    }

    SearchResults.init = function init(args) {
        if (args.IsEditorEditing === true) {
            $(args.scope).removeClass("js-hide-on-load");
            return null;
        }

        return new SearchResults(
            args.scope,
            args.UniqueId,
            args.RefreshActionMessages || [],
            args.ShowMessagesTransmitting || [],
            args.LazySearch,
            args.TileName,
            args.SwitchToClassicPager,
            args.ClassicPagerButtonsToDisplay,
            args.ShowPagerEllipsisInBetween,
            args.ScrollToPageTop);
    };

    return SearchResults;
}));
